const OnTheWayIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.305908"
        y="0.572876"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#FDB52A"
      />
      <g clip-path="url(#clip0_12_4215)">
        <path
          d="M8 25L8.5 23H14L13.5 25H8ZM10 21L10.5 19H17L16.5 21H10ZM25.575 27L26.075 23L26.8 17L27.05 15.025L25.575 27ZM13 29C12.45 29 11.9792 28.8042 11.5875 28.4125C11.1958 28.0208 11 27.55 11 27H25.575L27.05 15.025H24.3L24.025 17.15C23.9917 17.4333 23.8667 17.6542 23.65 17.8125C23.4333 17.9708 23.1833 18.0333 22.9 18C22.6167 17.9667 22.3958 17.8458 22.2375 17.6375C22.0792 17.4292 22.0167 17.1833 22.05 16.9L22.275 15.025H18.3L18.025 17.125C17.9917 17.4083 17.8667 17.6333 17.65 17.8C17.4333 17.9667 17.1833 18.0333 16.9 18C16.6167 17.9667 16.3917 17.8417 16.225 17.625C16.0583 17.4083 15.9917 17.1583 16.025 16.875L16.25 15.025H12.5C12.5667 14.4583 12.7833 13.9792 13.15 13.5875C13.5167 13.1958 13.9667 13 14.5 13H16.5C16.6333 11.75 17.0625 10.7708 17.7875 10.0625C18.5125 9.35417 19.5 9 20.75 9C21.8167 9 22.7042 9.39583 23.4125 10.1875C24.1208 10.9792 24.4667 11.9167 24.45 13H27C27.6 13.0167 28.1 13.25 28.5 13.7C28.9 14.15 29.0583 14.675 28.975 15.275L27.475 27.275C27.4083 27.775 27.1875 28.1875 26.8125 28.5125C26.4375 28.8375 26 29 25.5 29H13ZM18.5 13H22.475C22.4917 12.45 22.3042 11.9792 21.9125 11.5875C21.5208 11.1958 21.05 11 20.5 11C19.9167 11 19.4542 11.1792 19.1125 11.5375C18.7708 11.8958 18.5667 12.3833 18.5 13Z"
          fill="#FFA500"
        />
      </g>
      <defs>
        <clipPath id="clip0_12_4215">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(9 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OnTheWayIcon;
